import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.whiteish,
  textColor: colors.onyx,
  textColorDark: colors.onyx,
  textColorLight: colors.white
};
export default pencilBanner;